// Treemap utilities — framework-free helpers for the <Treemap> chart. (Tiling is
// handled by Recharts' <Treemap>; these are the small label helpers it reuses.)

/** Truncate a string to n chars with a trailing ellipsis. */
export const truncate = (s, n) => (s && s.length > n ? `${s.slice(0, n - 1)}…` : s);

/** Whether a #rrggbb fill is light enough to need dark text on top (WCAG relative luminance). */
export const isLightColor = (hex) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  if (!m) return false;
  const [r, g, b] = [m[1], m[2], m[3]].map((c) => parseInt(c, 16) / 255);
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return L > 0.55;
};
